import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class SharedService {
  private dataSource = new BehaviorSubject<any>({});
  getData = this.dataSource.asObservable();
  constructor() { }
  /**
   * [setData]
   * @param data 
   * @param origin 
   */
  setData(data: any, origin: string) {
    const objSend = {
      data: data,
      origin: origin
    };
    this.dataSource.next(objSend)
  }

  resetSourceShared() {
    this.dataSource.next({});
  }
}
